import useGetUserProductsRating from './useGetUserProductsRating'

export default useGetUserProductsRating
